import { Card, Skeleton, Stack, Typography } from '@mui/material';

export const ListingsStepSkeleton = () => (
  <Stack
    sx={{
      gap: 3,
      m: 2,
    }}
  >
    <Stack direction="row">
      <Skeleton variant="circular" width={24} height={24} sx={{ mr: 2 }} />
      <Skeleton variant="rounded" width="40%" height={24} />
    </Stack>
    <Stack
      sx={{
        gap: 2,
      }}
    >
      {Array.from({ length: 5 }).map((_, idx) => (
        <Card
          key={`comparable-skeleton-${idx}`}
          variant="outlined"
          elevation={0}
        >
          <Typography variant="h6">
            <Skeleton />
          </Typography>
          <Typography variant="h4">
            <Skeleton />
          </Typography>
        </Card>
      ))}
    </Stack>
  </Stack>
);

export default ListingsStepSkeleton;
